import { Component, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'fn-grid-number-filter',
	templateUrl: 'fn-grid-filter.component.html',
	styleUrls: ['fn-grid-filter.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnGridNumberFilterComponent {}
